import { WithProviders } from './providers'

export const App = () => {
    return <WithProviders />
}
